import React from 'react';
import PropTypes from 'prop-types';

import { FormattedHTMLMessage } from 'view-components/utilities/intl';

import UpperSectionAlert from 'view-components/components/Dialog/UpperSection/Alert';
import { LowerSectionText } from 'view-components/components/Dialog/Components';

import LowerSectionDeleteConfirm from './Components/LowerSectionDeleteConfirm';
import confirmableDialog from './Components/ConfirmableDialog';
import { DialogProps } from 'global/types';

interface Props extends DialogProps {
  deleteName: string
}

function LowerContent() {
  return (
    <LowerSectionText>
      <FormattedHTMLMessage
        id="app.dialog.delete_ad_sync.lower_section"
      />
    </LowerSectionText>
  );
}

function DeleteADSyncDialogContentFn(props: Props) {
  const {
    deleteName = '',
    isConfirmed = false,
    onConfirm = () => {},
    onDismiss = () => {},
    toggleConfirmed = () => {},
  } = props;

  return (
    <div>
      <UpperSectionAlert>
        <FormattedHTMLMessage
          id="app.dialog.delete_ad_sync.message"
          values={{ firstName: deleteName }}
        />

      </UpperSectionAlert>

      <LowerSectionDeleteConfirm
        toggleConfirmed={toggleConfirmed}
        isConfirmed={isConfirmed}
        deleteMessage={
          <FormattedHTMLMessage
            id="app.dialog.delete_ad_sync.confirm"
          />
        }
        onConfirm={onConfirm}
        additionalTopContent={<LowerContent />}
        onDismiss={onDismiss}
      />
    </div>
  );
}

DeleteADSyncDialogContentFn.propTypes = {
  deleteName: PropTypes.string,
  isConfirmed: PropTypes.bool,
  onConfirm: PropTypes.func,
  onDismiss: PropTypes.func,
  toggleConfirmed: PropTypes.func,
};

const DeleteADSyncDialogContent = confirmableDialog(DeleteADSyncDialogContentFn);

export default DeleteADSyncDialogContent;
